import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-504eee8f"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "center bgfff"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "custom-tabs-label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconpersonal-01"
}), /*#__PURE__*/_createElementVNode("span", null, "Your profile")], -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "custom-tabs-label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconlicense1"
}), /*#__PURE__*/_createElementVNode("span", null, "License")], -1));

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "custom-tabs-label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconorder-01"
}), /*#__PURE__*/_createElementVNode("span", null, "Order")], -1));

const _hoisted_5 = {
  class: "route-view"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");

  const _component_router_view = _resolveComponent("router-view");

  const _component_el_tabs = _resolveComponent("el-tabs");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_tabs, {
    "tab-position": "top",
    modelValue: _ctx.activeIndex,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.activeIndex = $event),
    onTabChange: _ctx.changeTab
  }, {
    default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
      name: "profile",
      class: "tab-pane"
    }, {
      label: _withCtx(() => [_hoisted_2]),
      _: 1
    }), _createVNode(_component_el_tab_pane, {
      name: "licenseManagement",
      class: "tab-pane"
    }, {
      label: _withCtx(() => [_hoisted_3]),
      _: 1
    }), _createVNode(_component_el_tab_pane, {
      name: "orderManagement",
      class: "tab-pane"
    }, {
      label: _withCtx(() => [_hoisted_4]),
      _: 1
    }), _createElementVNode("div", _hoisted_5, [_createVNode(_component_router_view)])]),
    _: 1
  }, 8, ["modelValue", "onTabChange"])]);
}